import { FC } from "react";
import { DatePicker } from "antd";
import { PassengerDateFieldProps } from "../PassengerDateField";

const PassengerDateFieldWeb: FC<PassengerDateFieldProps> = ({ value, onChange, disabledDate, className }) => {
  return (
    <DatePicker
      value={value as any}
      onChange={onChange}
      disabledDate={disabledDate}
      format={{ format: "DD/MM/YYYY", type: "mask" }}
      style={{ width: "100%" }}
      className={className ?? "p-2!"}
    />
  );
};

export default PassengerDateFieldWeb;
